import { render, staticRenderFns } from "./detaliLock.vue?vue&type=template&id=59ff1a03&"
import script from "./detaliLock.vue?vue&type=script&lang=js&"
export * from "./detaliLock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports